import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import Text from '../../atoms/Text';
import Image from '../../atoms/Image';
import WalletWatchlistStar from '../../pages/WalletPage/Overview/WalletWatchlistStar';

import paper from '../../assets/images/paper.svg';

import './styles.scss';

interface IStatsShortProps {
  walletAddress: string;
  buyCount: number;
  sellCount: number;
  bot: boolean;
  chain: string;
  showWatchlist: boolean;
  onShowModal: () => void;
}

const StatsShort = ({
  buyCount,
  sellCount,
  bot,
  walletAddress,
  chain,
  showWatchlist,
  onShowModal,
}: IStatsShortProps) => {
  return (
    <div className='stats_column'>
      <Image
        data-tip='Bot / Smart Contract'
        src={bot ? paper : undefined}
        size='m'
      />
      <div
        className='stats_column__icon icon-eye'
        onClick={onShowModal}
        data-tip='Show detailed info'
        data-for={`top-wallets-actions-tooltip-${walletAddress}`}
      />
      <Link
        to={`/en/wallet-overview/${chain}/${walletAddress}`}
        className='stats_column__icon icon-wallet'
        onClick={(e) => e.stopPropagation()}
        data-tip='Open in Wallet Analyzer'
        data-for={`top-wallets-actions-tooltip-${walletAddress}`}
      />
      {showWatchlist && (
        <div className='stats_column__watchlist'>
          <WalletWatchlistStar
            data={{
              type: 'traders',
              address: walletAddress,
              chain: chain,
            }}
          />
        </div>
      )}
      <Text size={12} className='info text--grey-600 text--weight-500'>
        {buyCount + sellCount}
      </Text>
      <ReactTooltip
        id={`top-wallets-actions-tooltip-${walletAddress}`}
        place='left'
        effect='solid'
        overridePosition={({ left }) => {
          return {
            left: left,
            top: -2,
          };
        }}
        className='actions__tooltip text_tooltip'
      />
    </div>
  );
};

export default StatsShort;
